import React, {useState, useEffect, useContext} from 'react';
import {Alert, Button, Card, Col, Form, Row, Modal } from 'react-bootstrap';
import EventContext from '../Visitation/context';
import uuid from 'react-uuid';
import {ACTIONS as EVENT_ACTION} from './Event/action';


const units = {
  weeks: 10080,
  days: 1440,
  hours: 60,
  minutes: 1,
}

const calculateReminder = (minutes) => {
  switch (true) {
    case minutes / 10080 >= 1:
      return {
        value: Math.floor(minutes / 10080),
        time: 'weeks',
      };
    case minutes / 1440 >= 1:
      return {
        value: Math.floor(minutes / 1440),
        time: 'days',
      };
    case minutes / 60 >= 1:
      return {
        value: Math.floor(minutes / 60),
        time: 'hours',
      };
    default:
      return {
        value: minutes,
        time: 'minutes',
      };
  }
}

const calculateMinutes = (timeframe, value) => {
  return units[timeframe] * value;
}

const Reminder = ({reminder = null}) => {

  const [duration, setDuration] = useState(0);
  const [timeframe, setTimeframe] = useState(
    reminder?.minutes
      ? calculateReminder(reminder.minutes).time
      : `minutes`
  );

  const {popup, dispatchPopup} = useContext(EventContext);

  const handleDelete = (uuid) => {
    dispatchPopup({
      type: EVENT_ACTION.UPDATE,
      payload: {
        reminders: popup.reminders.filter(reminder => reminder.uuid !== uuid),
      }
    });
  }


  const handleChangeMethod = ({target: {value}}) => {
    dispatchPopup({
      type: EVENT_ACTION.UPDATE,
      payload: {
        reminders: popup.reminders.map(item => {
          if (item.uuid === reminder.uuid) {
            return {
              ...item,
              method: value,
            }
          }

          return item;
        })
      }
    });
  }

  const handleChangeDuration = ({target: {value}}) => {
    dispatchPopup({
      type: EVENT_ACTION.UPDATE,
      payload: {
        reminders: popup.reminders.map(item => {
          if (item.uuid === reminder.uuid) {
            return {
              ...item,
              minutes: calculateMinutes(timeframe, parseInt(value)),
            }
          }

          return item;
        })
      }
    });
  }

  const handleChangeTimeframe = ({target: {value}}) => {

    dispatchPopup({
      type: EVENT_ACTION.UPDATE,
      payload: {
        reminders: popup.reminders.map(item => {
          if (item.uuid === reminder.uuid) {
            const selectedDurationUnit = calculateReminder(item.minutes);
            return {
              ...item,
              minutes: selectedDurationUnit.value * units[value],
            }
          }

          return item;
        })
      }
    });
    setTimeframe(value);
  }

  return (
    <Row>
      <Col md="4">
        <Form.Group>
          <Form.Control as="select"
            value={reminder.method}
            onChange={handleChangeMethod}
          >
            <option value='popup'>Notification</option>
            <option value='email'>Email</option>
          </Form.Control>
        </Form.Group>
      </Col>
      <Col md="2">
        <Form.Group>
          <Form.Control type="number"
            value={calculateReminder(reminder.minutes).value}
            onChange={handleChangeDuration}
          />
        </Form.Group>
      </Col>
      <Col md="4">
        <Form.Group>
          <Form.Control as="select"
            value={timeframe}
            onChange={handleChangeTimeframe}
          >
            <option value='minutes'>Minutes</option>
            <option value='hours'>Hours</option>
            <option value='days'>Days</option>
            <option value='weeks'>Weeks</option>
          </Form.Control>
        </Form.Group>
      </Col>
      <Col md="1">
        <Form.Group>
          <Button variant="danger" onClick={() => handleDelete(reminder.uuid)}>X</Button>
        </Form.Group>
      </Col>
    </Row>
  )
}


export default Reminder;